import { FC } from 'react'

import { Controller, FieldError, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AppealsSubjects, KeyValue } from 'shared/api/AppealModel'
import { Paper } from 'shared/ui/paper'
import { Select } from 'shared/ui/select'
import { SelectMulti } from 'shared/ui/select-multi'
import { TextArea } from 'shared/ui/text-area'
import UploadFiles from 'shared/ui/upload-files'

import { FormFeedBack } from '../../appeal-form-ticket'

import s from './styles.module.scss'

interface Option {
  value: string
  name: string
}

interface Props {
  passengersOptions?: Option[]
  listTypeOfAppeal: Option[]
  topics?: AppealsSubjects
  listTopics: KeyValue[]
}

const MAX_LENGTH = 1000

export const AppealForm: FC<Props> = ({
  passengersOptions,
  listTypeOfAppeal,
  listTopics,
  topics,
}) => {
  const { t } = useTranslation()

  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<FormFeedBack>()

  return (
    <div className={s.container}>
      <Paper padding={[16]}>
        <p className={s.title}>{t('detail_ticket.filed_form')}</p>

        <div className={s.form}>
          <Controller
            name={'topic'}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Select
                key={field?.value}
                options={listTypeOfAppeal}
                error={errors?.topic}
                value={String(field.value)}
                placeholder={t('feed_back.select_subject') + '*'}
                onChange={(option) => {
                  const listTopics: KeyValue[] | [] =
                    topics?.[option?.value as keyof object] || []

                  if (listTopics?.length) {
                    setValue('subject', String(listTopics[0]?.key))
                  } else {
                    setValue('subject', '')
                  }

                  field.onChange(option.value)
                }}
              />
            )}
          />

          <Controller
            name={'subject'}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Select
                key={field?.value}
                options={listTopics?.map((item) => ({
                  value: String(item?.key),
                  name: item.value,
                }))}
                error={errors?.subject}
                value={String(field.value)}
                disabled={listTopics?.length === 0}
                placeholder={t('select_type_refund') + '*'}
                onChange={(option) => field.onChange(option.value)}
              />
            )}
          />

          {passengersOptions ? (
            <div className={s.itemWhite}>
              <Controller
                control={control}
                rules={{ required: true }}
                name={`passengers`}
                render={({ field }) => (
                  <SelectMulti
                    title={t('passengers')}
                    options={passengersOptions}
                    placeholder={t('select_passengers') + '*'}
                    error={errors?.passengers as FieldError}
                    onChange={(value) => field.onChange(value)}
                    value={field?.value?.map((item) => item.value)}
                  />
                )}
              />
            </div>
          ) : null}

          <TextArea
            error={errors?.description}
            {...register('description', {
              required: true,
              maxLength: MAX_LENGTH,
            })}
            placeholder={t('feed_back.describe') + '*'}
          />

          <div className={s.upload}>
            <Controller
              name={`files`}
              control={control}
              render={({ field }) => (
                <UploadFiles
                  files={field.value}
                  error={errors?.files as FieldError}
                  onLoadFiles={(files) => field?.onChange(files)}
                />
              )}
            />
          </div>
        </div>
      </Paper>
    </div>
  )
}
